import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppRouter } from './AppRouter';
import './index.css';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-3467">
    <HelmetProvider data-id="element-3468">
      <ErrorBoundary data-id="element-3469">
        <AppRouter data-id="element-3470" />
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>);
// Signal to pre-renderers that the page is fully rendered
// Uses setTimeout(0) for maximum compatibility — signals after the next tick
// This is safer than requestIdleCallback which can delay in some environments
setTimeout(() => {
  ;
  (window as any).prerenderReady = true;
  document.dispatchEvent(new Event('render-event'));
}, 0);